module.exports = __webpack_public_path__ + "img/img08.acf41dca.svg";